import { Radio } from 'antd'
import classNames from 'classnames'
import { Row } from 'react-bootstrap'
import { useState } from 'react'

import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import Loader, { LoaderSizes } from 'components/ui/loader/Loader'
import styles from './SelectTypeProfile.module.scss'

const RadioOption = ({ value, option, label, description }) => (
  <div className={classNames('col-12 col-md-4', styles.radioColumn)}>
    <Row
      noGutters
      className={classNames(styles.radio, option === value && styles.checked)}
    >
      <Radio value={option} className="w-100">
        <div className={styles.radioWrapper}>
          <div className={classNames('text-truncate', styles.title)}>
            {label}
          </div>
          <div className={classNames('text-wrap', styles.description)}>
            {description}
          </div>
        </div>
      </Radio>
    </Row>
  </div>
)

interface SelectTypeProfileProps {
  value?: LmsProfileTypes | null
  onChange?: (type?: LmsProfileTypes | null) => void | Promise<void>
}

export function SelectTypeProfile({ value, onChange }: SelectTypeProfileProps) {
  const [changing, setChanging] = useState(false)
  const tRelative = useTranslationRankmi({
    prefix: 'configuration.lmsProfiles.form.types',
  })

  return (
    <div>
      <h6 className={classNames('mt-4 blue-darken mb-4', styles.header)}>
        {tRelative('titleV2')}
      </h6>
      <div className="position-relative">
        <Radio.Group
          value={value}
          className={classNames('row', styles.radioGroup)}
          onChange={async (event) => {
            const newValue = event.target.value
            setChanging(newValue)
            try {
              await onChange?.(newValue)
            } finally {
              setChanging(false)
            }
          }}
          disabled={changing}
        >
          <RadioOption
            value={value}
            option={LmsProfileTypes.allUsers}
            label={tRelative('allUsers.title')}
            description={tRelative('allUsers.description')}
          />
          <RadioOption
            value={value}
            option={LmsProfileTypes.segments}
            label={tRelative('segments.title')}
            description={tRelative('segments.description')}
          />
          <RadioOption
            value={value}
            option={LmsProfileTypes.participants}
            label={tRelative('participants.title')}
            description={tRelative('participants.description')}
          />
        </Radio.Group>
        {changing && (
          <div className={styles.loading}>
            <Loader
              color
              className={styles.loader}
              classes={{
                loader: classNames(
                  'p-1 d-flex justify-content-center align-items-center',
                  styles.loader
                ),
              }}
              sizes={LoaderSizes.Small}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectTypeProfile
